<template>
  <v-dialog v-model="$parent.popup.isVisible" persistent width="400">
    <v-card>
      <v-toolbar class="trHeader" style="height: 40px;">
        <v-toolbar-title class="white--text" style="text-align:center;">{{$parent.popup.title}}</v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs3 right>
          שם לקוח
        </v-flex>
        <v-flex xs9>
          <input type="text" v-model="$parent.popup.data.FullName" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs3 right>
          איש קשר
        </v-flex>
        <v-flex xs9>
          <input type="text" v-model="$parent.popup.data.ContactPerson" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs3 right>
          טלפון
        </v-flex>
        <v-flex xs9>
          <input type="text" v-model="$parent.popup.data.Phone" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs3 right>
          שם משתמש
        </v-flex>
        <v-flex xs9>
          <input type="text" v-model="$parent.popup.data.Username" />
        </v-flex>
      </v-layout>
      <!--<v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs3 right>
          סיסמה
        </v-flex>
        <v-flex xs9>
          <input type="text" v-model="$parent.popup.data.Password" />
        </v-flex>
      </v-layout>-->
      <v-flex row wrap style="padding: 10px 10px 10px 10px;">
        <span class="error" v-show="error">* {{error}}</span>
      </v-flex>
      <v-flex actions style="padding: 20px 10px 10px 10px;">
        <v-btn outline small class="green green--text ml-3" @click.native="save">
          שמירה
          <v-icon left>check</v-icon>
        </v-btn>
        <v-btn outline small class="red red--text ml-2" @click.native="cancel">
          ביטול
          <v-icon left>block</v-icon>
        </v-btn>
      </v-flex>
    </v-card>
  </v-dialog>
</template>

<script>
  import { db } from '../firebase';
  var usersRef = db.ref('Users');

  export default {
    name: 'PopupCustomer',
    data() {
      return {
        error: ''
      }
    },
    created() {
      this.$Log("Vue [PopupCustomer] is created ...");
    },
    ready() {
      this.$Log("Vue [PopupCustomer] is ready ...");
    },
    mounted() {
      this.$Log("Vue [PopupCustomer] is mounted ...");
    },
    updated() {
      this.$Log("Vue [PopupCustomer] is updated ...");
    },
    methods: {
      isValid(callback) {
        var vm = this;
        if (vm.$parent.popup.data.FullName.trim().length <= 0) return callback(false);
        if (vm.$parent.popup.data.ContactPerson && vm.$parent.popup.data.ContactPerson.trim().length <= 0) return callback(false);
        if (vm.$parent.popup.data.Phone && vm.$parent.popup.data.Phone.trim().length <= 0) return callback(false);
        //if (vm.$parent.popup.data.Password.trim().length <= 0) return callback(false);
        if (vm.$parent.popup.data.Username.trim().length <= 0) return callback(false);

        usersRef.orderByChild("Username").equalTo(vm.$parent.popup.data.Username.trim()).once('value').then(function (snapshot) {
          var obj = snapshot.val();
          if (obj) {
            var k = Object.keys(obj)[0];
            var usr = obj[k];
            if (usr.Type == 'רוכש') {
              callback(true);
            }
            else {
              callback("NO_USER");
            }
          }
          else {
            callback("NO_USER");
          }
        });
      },
      save() {
        var vm = this;
        vm.error = "";
        vm.isValid(function (valid) {
          if (valid == true) {
            if (vm.$parent.popup.isEdit) {
              vm.$parent.update();
            }
            else {
              vm.$parent.insert();
            }
            vm.reset();
          }
          else if (valid == "NO_USER") {
            vm.error = " שם משתמש לא קיים !"
          }
          else {
            vm.error = "נא למלא את כל השדות!"
          }
        });
      },
      cancel() {
        this.reset();
      },
      reset() {
        this.error = "";
        this.$parent.popup = {
          isVisible: false,
          isEdit: false,
          title: '',
          data: { '.key': '', FullName: '', ContactPerson: '', Phone: '', Username: '', TotalDiaries: 0, UsedDiaries: 0 }
        };
      }
    }
  }

</script>
<style>
  .error {
    color: red;
    background-color: #fff !important;
  }
</style>



// WEBPACK FOOTER //
// PopupCustomer.vue?5d4b8662